module.exports = __webpack_public_path__ + "img/alice-oseman.f32b5f72.png";